import {timeToComplete} from '@github-ui/mergebox/helpers/status-check-helpers'
import {isFailingOrIncompleteStatus, type StatusCheck} from '@github-ui/mergebox/page-data/payloads/status-checks'

export type FailedRequiredCheck = {
  key: string
  name: string
  detailText: string
  targetUrl: string | null
}

/**
 * Builds the detail line for a failed required check. Prefers the backend-provided
 * `additionalContext` when present; otherwise derives a state-aware conclusion via
 * `timeToComplete`
 */
export function failedCheckDetailText(check: StatusCheck): string {
  const context = check.additionalContext.trim()
  if (context.length > 0) return context
  return timeToComplete(check.state, check.durationInSeconds) || 'Failed'
}

/**
 * Pure transform from the full status checks list to the failed *required* checks
 * we surface as individual actionable items.
 */
export function selectFailedRequiredChecks(statusChecks: StatusCheck[]): FailedRequiredCheck[] {
  return statusChecks
    .filter(check => check.isRequired && isFailingOrIncompleteStatus(check.state))
    .map((check, index) => ({
      key: `${check.displayName}-${check.stateChangedAt}-${index}`,
      name: check.displayName,
      detailText: failedCheckDetailText(check),
      targetUrl: check.targetUrl,
    }))
}
